import { ObjectBuilder, Image3D, ImgButton, ImgButtonWithText, LayoutUtils, MeshUtils, Rectangle3D } from "@dreamcam/babylon-tools";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { Env } from "../../settings/Env";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { text } from "../../TextResources";
import { SubmenuHandlers } from "./SubmenuHandlers";
import { GuestPanel } from "./customComponents/GuestPanel";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { ClientPanel } from "./customComponents/ClientPanel";
import { MessengerButton } from "./MessengerButton";
import { globalOptions } from "../../settings/GlobalOptions";
import { AppView } from "../AppView";
// interface NewFeatureMark {
//     control: Control;
//     isAnimated: boolean;
// }
export class UserPanel {
    constructor(mesh, signoutMesh, callbacks, _newFeatureBlinkHelper) {
        this._loginDialog = undefined;
        this._isMessengerButtonOn = false;
        this._isEnvironmentButtonOn = false;
        this._isHelpButtonOn = false;
        // private _environmentData: Nullable<EnvironmentData> = null;
        this._flag = {
            loggingIn: false,
            loggingOut: false,
        };
        this._mesh2d = mesh;
        this._signoutMesh2D = signoutMesh;
        MeshUtils.hide(this._signoutMesh2D);
        this._callbacks = callbacks;
        // this._newFeatureBlinkHelper = newFeatureBlinkHelper;
        this._profileSubmenuHandlers = new SubmenuHandlers(this._signoutMesh2D);
        this._controls = this._createPanel();
        this._controls.clientButton.isVisible = false;
        this._createSignoutPanel();
    }
    show(_environmentData, environmentOrHelpButton) {
        // this._environmentData = environmentData;
        // const hasNewEnvironments = this._environmentData === null
        //     ? false
        //     : this._environmentData.allDescriptors.find(x => x.isNew === true) !== undefined;
        // this._setHasNewFeature(hasNewEnvironments);
        this._controls.environmentButton.isVisible = environmentOrHelpButton === "environment";
        this._controls.environmentButton.isEnabled = environmentOrHelpButton === "environment";
        this._controls.helpButton.isVisible = environmentOrHelpButton === "help";
        this._controls.helpButton.isEnabled = environmentOrHelpButton === "help";
        MeshUtils.setVisibility(this._mesh2d, true);
    }
    hide() {
        this._profileSubmenuHandlers.hideSubmenuInstantly();
        MeshUtils.setVisibility(this._mesh2d, false);
    }
    get isVisible() {
        return this._mesh2d.mesh.isVisible;
    }
    get isContentVisible() {
        return this._controls.contentContainer.isVisible;
    }
    set isContentVisible(value) {
        this._controls.contentContainer.isVisible = value;
    }
    outputMessengerLoggedState(isAuthorized) {
        if (!isAuthorized) {
            this.outputUnreadMessagesCount([]);
            this.isMessengerButtonOn = false;
        }
        // this._controls.messengerButton.isEnabled = isAuthorized;
    }
    outputUnreadMessagesCount(unreadChats) {
        const totalUnreadCount = unreadChats.reduce((sum, chat) => sum + chat.unread_count, 0);
        this._controls.unreadMessagesCountContainer.isVisible = totalUnreadCount > 0.001;
        const maxUnread = globalOptions.messengerMaxUnreadCount;
        this._controls.unreadMessagesCountTextBlock.text = totalUnreadCount > maxUnread ? `${maxUnread}+` : totalUnreadCount.toString();
    }
    outputUserData(data) {
        this._controls.guestButton.isVisible = data === undefined;
        this._controls.clientButton.isVisible = data !== undefined;
        this._controls.clientNicknameTextBlock.text = data?.nickname ?? "";
        // this._controls.balanceTextBlock.text = data?.tokens.toString() ?? "0";
        this._controls.clientBalanceTextBlock.text = new Intl.NumberFormat().formatToParts(data?.tokens ?? 0).map(v => {
            switch (v.type) {
                case "group": return " ";
                default: return v.value;
            }
        }).reduce((s, p) => s + p);
        // const up = Env.lobby.userPanel;
        // const nameWidth = ContextUtils.MeasureText(this._profileName, this._mesh2d.texture.getContext()) + this._mesh2d.m2px(up.profile.downArrrow.width + up.profile.downArrrow.padding.left);
        // const balanceWidth = ContextUtils.MeasureText(this._balance, this._mesh2d.texture.getContext()) + this._mesh2d.m2px(up.profile.token.width + up.profile.token.padding.left);
        // const contentWidth = Math.max(nameWidth, balanceWidth);
        // this._profileButton.widthInPixels = this._mesh2d.m2px(up.profile.photo.width + up.innerPanel.paddingLeft + up.innerPanel.paddingRight) + contentWidth;
        // this._profileButton.children[0]!.widthInPixels = this._profileButton.widthInPixels;
    }
    // private _setHasNewFeature(value: boolean) {
    //     this._menuNewFeatureMarks.forEach((mark: NewFeatureMark) => {
    //         mark.control.isVisible = value;
    //         if (mark.isAnimated) {
    //             if (value) {
    //                 this._newFeatureBlinkHelper.addNewFeatureDot(mark.control.name!, mark.control);
    //             } else {
    //                 this._newFeatureBlinkHelper.removeNewFeatureDot(mark.control.name!);
    //             }
    //         }
    //     });
    // }
    _clearDetectPointerOnOpaqueOnly(imgButton) {
        imgButton.children[0].detectPointerOnOpaqueOnly = false;
    }
    get isMessengerButtonOn() {
        return this._isMessengerButtonOn;
    }
    set isMessengerButtonOn(value) {
        if (value === this._isMessengerButtonOn)
            return;
        if (value)
            this.turnAllTogglersOff();
        const isMessengerAuthorized = AppView.getInstance().appController.messengerSdk.authManager.isAuthorized;
        if (value && (this._controls.guestButton.isVisible || !isMessengerAuthorized)) {
            setTimeout(async () => await this._loginHandlerAsync());
            return;
        }
        this._isMessengerButtonOn = value;
        const mb = Env.common.messengerButton;
        this._controls.messengerButton.changeLayout(value ? mb.activeImageLayout : mb.inactiveImageLayout);
        if (value) {
            this._callbacks.showMessengerDialog();
        }
        else {
            this._callbacks.hideMessengerDialog();
        }
    }
    get isEnvironmentButtonOn() {
        return this._isEnvironmentButtonOn;
    }
    set isEnvironmentButtonOn(value) {
        if (value === this._isEnvironmentButtonOn)
            return;
        if (value)
            this.turnAllTogglersOff();
        this._isEnvironmentButtonOn = value;
        const up = Env.lobby.userPanel2;
        this._controls.environmentButton.changeLayout(value
            ? up.environmentButton.activeImageLayout
            : up.environmentButton.inactiveImageLayout);
        if (value) {
            this._callbacks.showEnvironmentDialog();
        }
        else {
            this._callbacks.hideEnvironmentDialog();
        }
    }
    get isHelpButtonOn() {
        return this._isHelpButtonOn;
    }
    set isHelpButtonOn(value) {
        if (value === this._isHelpButtonOn)
            return;
        // if (value) this.turnAllTogglersOff(); // Turning on/off the help button doesn't switch other buttons
        this._isHelpButtonOn = value;
        this.updateHelpButton();
        if (value) {
            this._callbacks.showHelpDialog();
        }
        else {
            this._callbacks.hideHelpDialog();
        }
    }
    updateHelpButton() {
        const up = Env.lobby.userPanel2;
        this._controls.helpButton.changeLayout(this._isHelpButtonOn
            ? up.helpButton.activeImageLayout
            : up.helpButton.inactiveImageLayout);
    }
    setLoginDialog(loginDialog) {
        this._loginDialog = loginDialog;
    }
    turnAllTogglersOff() {
        if (this._loginDialog?.isVisible === true) {
            this._loginDialog.hide();
        }
        this.isMessengerButtonOn = false;
        this.isEnvironmentButtonOn = false;
        // this.isHelpButtonOn = false; // Turning on/off the help button doesn't switch other buttons
    }
    async _loginHandlerAsync() {
        if (this._flag.loggingIn)
            return;
        this._flag.loggingIn = true;
        try {
            await this._callbacks.loginAsync();
        }
        finally {
            this._flag.loggingIn = false;
        }
    }
    _createPanel() {
        const up = Env.lobby.userPanel2;
        const rootContainer = new Rectangle3D();
        rootContainer.thickness = 0;
        rootContainer.background = up.background;
        rootContainer.cornerRadius = this._mesh2d.m2px(up.cornerRadius);
        rootContainer.widthInPixels = this._mesh2d.m2px(up.width);
        rootContainer.heightInPixels = this._mesh2d.m2px(up.height);
        rootContainer.clipChildren = true;
        this._mesh2d.texture.addControl(rootContainer);
        const contentContainer = new Container("userPanelContentContainer");
        rootContainer.addControl(contentContainer);
        // Login button:
        {
            const guestPanel = new GuestPanel(this._mesh2d, { left: this._mesh2d.m2px(up.guestPanel.left), top: this._mesh2d.m2px(up.guestPanel.top) }, { width: this._mesh2d.m2px(up.guestPanel.width), height: this._mesh2d.m2px(up.guestPanel.height) }, false);
            guestPanel.rootContainer.verticalAlignment = Container.VERTICAL_ALIGNMENT_CENTER;
            contentContainer.addControl(guestPanel.rootContainer);
            var guestButton = guestPanel.rootContainer;
            guestPanel.guestButton.onClickObserver.add(async () => await this._loginHandlerAsync());
        }
        // Profile button:
        {
            const clientPanel = new ClientPanel(this._mesh2d, { left: this._mesh2d.m2px(up.clientPanel.left), top: this._mesh2d.m2px(up.clientPanel.top) }, { maxWidth: this._mesh2d.m2px(up.clientPanel.maxWidth), height: this._mesh2d.m2px(up.clientPanel.height) });
            clientPanel.clientButton.verticalAlignment = Container.VERTICAL_ALIGNMENT_CENTER;
            contentContainer.addControl(clientPanel.clientButton);
            var clientButton = clientPanel.clientButton;
            var clientNicknameTextBlock = clientPanel.nicknameTextBlock;
            var clientBalanceTextBlock = clientPanel.balanceAmountTextBlock;
            clientButton.onClickObserver.add(() => {
                if (this.isVisible) {
                    if (this._callbacks.onShowProfileSubmenu)
                        this._callbacks.onShowProfileSubmenu();
                    this._profileSubmenuHandlers.showSubmenu(SubmenuHandlers.longLifetime);
                }
            });
        }
        const stackPanelButtons = new StackPanel("userPanelButtons");
        stackPanelButtons.isVertical = false;
        stackPanelButtons.horizontalAlignment = StackPanel.HORIZONTAL_ALIGNMENT_RIGHT;
        contentContainer.addControl(stackPanelButtons);
        const getTokensButton = new ImgButtonWithText("userPanelGetTokensButton", {
            imageLayout: LayoutUtils.GetButtonLayout(up.getTokensButton.colorLayout, this._mesh2d),
            textLayout: this._mesh2d.textLayoutM2Px(up.getTokensButton.textLayout),
            text: text.lobby_topUp,
        });
        getTokensButton.widthInPixels = this._mesh2d.m2px(up.getTokensButton.width);
        getTokensButton.heightInPixels = this._mesh2d.m2px(up.getTokensButton.height);
        getTokensButton.onClickObserver.add(async () => await this._callbacks.topUpAsync());
        stackPanelButtons.addControl(getTokensButton);
        const createGap = (widthInPixels) => {
            const result = new Control("userPanelGap");
            result.widthInPixels = widthInPixels;
            result.heightInPixels = 1;
            return result;
        };
        const createGap8 = () => createGap(this._mesh2d.m2px(up.gaps.width8));
        const createGap16 = () => createGap(this._mesh2d.m2px(up.gaps.width16));
        stackPanelButtons.addControl(createGap16());
        const separator = new Rectangle3D("userPanelSeparator");
        separator.widthInPixels = this._mesh2d.m2px(up.separator.width);
        separator.heightInPixels = this._mesh2d.m2px(up.separator.height);
        separator.cornerRadius = this._mesh2d.m2px(up.separator.cornerRadius);
        separator.background = up.separator.color;
        stackPanelButtons.addControl(separator);
        stackPanelButtons.addControl(createGap16());
        const messengerButton = MessengerButton.create(this._mesh2d);
        messengerButton.messengerButton.onClickObserver.add(() => {
            setTimeout(() => this.isMessengerButtonOn = !this.isMessengerButtonOn);
        });
        if (globalOptions.featureMessenger) {
            stackPanelButtons.addControl(messengerButton.messengerButton);
        }
        stackPanelButtons.addControl(createGap8());
        const environmentButton = new ImgButton("environmentButton", this._isEnvironmentButtonOn ? up.environmentButton.activeImageLayout : up.environmentButton.inactiveImageLayout);
        environmentButton.widthInPixels = this._mesh2d.m2px(up.environmentButton.width);
        environmentButton.heightInPixels = this._mesh2d.m2px(up.environmentButton.height);
        environmentButton.onClickObserver.add(() => setTimeout(() => this.isEnvironmentButtonOn = !this.isEnvironmentButtonOn));
        this._clearDetectPointerOnOpaqueOnly(environmentButton);
        stackPanelButtons.addControl(environmentButton);
        const helpButton = new ImgButton("helpButton", this._isHelpButtonOn ? up.helpButton.activeImageLayout : up.helpButton.inactiveImageLayout);
        helpButton.widthInPixels = this._mesh2d.m2px(up.helpButton.width);
        helpButton.heightInPixels = this._mesh2d.m2px(up.helpButton.height);
        helpButton.onClickObserver.add(() => setTimeout(() => this.isHelpButtonOn = !this.isHelpButtonOn));
        this._clearDetectPointerOnOpaqueOnly(helpButton);
        stackPanelButtons.addControl(helpButton);
        stackPanelButtons.addControl(createGap8());
        const exitXrButton = new ImgButton("exitXrButton", up.exitXrButton.imageLayout);
        exitXrButton.widthInPixels = this._mesh2d.m2px(up.exitXrButton.width);
        exitXrButton.heightInPixels = this._mesh2d.m2px(up.exitXrButton.height);
        exitXrButton.onClickObserver.add(async () => await this._callbacks.exitXrAsync());
        this._clearDetectPointerOnOpaqueOnly(exitXrButton);
        stackPanelButtons.addControl(exitXrButton);
        stackPanelButtons.addControl(createGap16());
        return {
            contentContainer,
            guestButton,
            clientButton,
            clientNicknameTextBlock,
            clientBalanceTextBlock,
            messengerButton: messengerButton.messengerButton,
            unreadMessagesCountContainer: messengerButton.unreadMessagesCountContainer,
            unreadMessagesCountTextBlock: messengerButton.unreadMessagesCountTextBlock,
            environmentButton,
            helpButton,
            exitXrButton,
        };
    }
    _createSignoutPanel() {
        const onPointerEnterHandler = () => {
            this._profileSubmenuHandlers.hideSubmenuCancel();
        };
        const onPointerOutHandler = () => {
            this._profileSubmenuHandlers.hideSubmenuStart(SubmenuHandlers.shortLifetime);
        };
        const up = Env.lobby.userPanel2;
        const rootContainer = new Rectangle3D("userSignoutPanel");
        rootContainer.thickness = 0;
        rootContainer.background = up.signoutPanel.background;
        rootContainer.cornerRadius = this._signoutMesh2D.m2px(up.cornerRadius);
        rootContainer.widthInPixels = this._signoutMesh2D.m2px(up.signoutPanel.width);
        rootContainer.heightInPixels = this._signoutMesh2D.m2px(up.signoutPanel.height);
        rootContainer.onPointerEnterObservable.add(onPointerEnterHandler);
        rootContainer.onPointerOutObservable.add(onPointerOutHandler);
        rootContainer.clipChildren = true;
        this._signoutMesh2D.texture.addControl(rootContainer);
        const logoutButton = new ImgButton("userSignoutPanelItem", LayoutUtils.GetButtonLayout(up.signoutPanel.item.layout, this._signoutMesh2D));
        logoutButton.widthInPixels = this._signoutMesh2D.m2px(up.signoutPanel.item.width);
        logoutButton.heightInPixels = this._signoutMesh2D.m2px(up.signoutPanel.item.height);
        logoutButton.onPointerEnterObservable.add(onPointerEnterHandler);
        logoutButton.onPointerOutObservable.add(onPointerOutHandler);
        logoutButton.onPointerClickObservable.add(async () => {
            if (this._flag.loggingOut)
                return;
            setTimeout(async () => {
                this._flag.loggingOut = true;
                try {
                    this._profileSubmenuHandlers.hideSubmenuInstantly();
                    await this._callbacks.logoutAsync();
                }
                finally {
                    this._flag.loggingOut = false;
                }
            });
        });
        rootContainer.addControl(logoutButton);
        const signoutStackPanel = new StackPanel("userSignoutPanelItemStackPanel");
        signoutStackPanel.isVertical = false;
        signoutStackPanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        logoutButton.addControl(signoutStackPanel);
        const signoutImg = new Image3D("userSignoutPanelItemImage", up.signoutPanel.item.image.src);
        signoutImg.widthInPixels = this._signoutMesh2D.m2px(up.signoutPanel.item.image.width);
        signoutImg.heightInPixels = this._signoutMesh2D.m2px(up.signoutPanel.item.image.height);
        signoutStackPanel.addControl(signoutImg);
        const signoutTextBlock = ObjectBuilder.createTextBlock3D(this._signoutMesh2D, "userSignoutPanelItemText", text.lobby_userPanel_signout, up.signoutPanel.item.text);
        signoutStackPanel.addControl(signoutTextBlock);
    }
}
